export default "__VITE_ASSET__Bwhqg8tv__"